<style scoped lang="scss" type="text/scss">
    .rectangular-text {
        width: 1.2rem;
        height: 1.2rem;
        font-size: .75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .1rem;
        color: #FFF;
    }
</style>

<template>
    <div class="rectangular-text" :style="{'background-color': bgColor}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        props: ['bg-color'],
        data () {
            return {};
        }
    };
</script>
